import type { VariantOf } from 'variant';
import { fields, match, variant, lookup } from 'variant';
import { join } from 'node:path';
import type { IdeForMcp } from './ConfigMcp.js';

export const McpConfigResult = variant({
  Created: fields<{ mcpPath: string; ideForMcp: IdeForMcp; docsUrl: string }>(),
  Canceled: {},
});

export type McpConfigResult = VariantOf<typeof McpConfigResult>;

const getMcpData = ({
  ideForMcp,
  packageFolder,
}: {
  ideForMcp: IdeForMcp;
  packageFolder: string;
}) => {
  const mcpPath = match(ideForMcp, {
    Cursor: () => join(packageFolder, '.cursor', 'mcp.json'),
    VsCode: () => join(packageFolder, '.vscode', 'mcp.json'),
    ClaudeCode: () => join(packageFolder, '.mcp.json'),
  });

  return McpConfigResult.Created({
    mcpPath,
    ideForMcp,
    docsUrl: match(
      ideForMcp,
      lookup({
        Cursor: 'https://cursor.com/docs/context/mcp',
        VsCode: 'https://code.visualstudio.com/docs/copilot/chat/mcp-servers',
        ClaudeCode: 'https://docs.anthropic.com/en/docs/claude-code/mcp',
      })
    ),
  });
};

export const getMcpResult = ({
  ideForMcp,
  targetParentFolder,
  packageName,
}: {
  ideForMcp: IdeForMcp | undefined;
  packageName: string;
  targetParentFolder: string;
}): McpConfigResult => {
  const packageFolder = join(targetParentFolder, packageName);
  return ideForMcp
    ? getMcpData({
        ideForMcp,
        packageFolder,
      })
    : McpConfigResult.Canceled();
};
